import { EmailPayloadBase } from "../email-payload-base";

export class AnnualStatementBulkEsignEmailPayload extends EmailPayloadBase {
  static override $type = 'AnnualStatementBulkEsignEmailPayload';

  companyNames: string[];
  year: string;
  directorFirstName: string;
  directorFullName: string;
  username: string;
  signUrl: string;
  payUrl: string;

  constructor(data: Partial<AnnualStatementBulkEsignEmailPayload> = {}) {
    super(data);
    this.companyNames = data.companyNames ?? [];
    this.year = data.year ?? '';
    this.directorFirstName = data.directorFirstName ?? '';
    this.directorFullName = data.directorFullName ?? '';
    this.username = data.username ?? '';
    this.signUrl = data.signUrl ?? '';
    this.payUrl = data.payUrl ?? '';
  }
}
